import React, { useEffect, useState } from "react";
import {
  customer_subscription,
  card_details,
  cancel_subscription,
  cancel_card_details,
} from "../../../redux/authslice";
import "./plan.css";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const Plandetails = () => {
  const heading = {
    Plan: [
      {
        label: ["S.No", "Interval", "Price", "Level"],
      },
    ],
    Card: [
      {
        label: ["S.No", "Card on Name", "Card Number", "Expiry Year"],
      },
    ],
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { customersubscrip, cardDetails } = useSelector(
    (state) => state.counter
  );
  const [selectedBrand, setSelectedBrand] = useState("Plan");
  const [lebl, setLebl] = useState([]);
  const [subid, setSubid] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setSubid(id);
    setShow(true);
  };

  const handlesubcrip = () => {
    let id = subid;
    dispatch(cancel_subscription({ id, setShow, dispatch }));
    setShow(false);
  };

  const handleDelete = (id) => {
    dispatch(cancel_card_details({ id, dispatch, setShow }));
  };

  const getIntervaldata = (interval, intervalCount) => {
    if (interval === "month") {
      if (intervalCount === 1) return "Monthly";
      if (intervalCount === 3) return "Quarterly";
    } else if (interval === "year" && intervalCount === 1) {
      return "Yearly";
    }
    return `${intervalCount} ${interval}`;
  };

  useEffect(() => {
    const getLabels = () => {
      setLebl(
        selectedBrand === "Card" ? heading.Card[0].label : heading.Plan[0].label
      );
    };
    getLabels();
  }, [selectedBrand]);

  useEffect(() => {
    dispatch(customer_subscription(dispatch));
    dispatch(card_details({ dispatch }));
  }, [dispatch]);

  return (
    <>
      <section className="Privacy">
        <div className="container">
          <button className="div-save-bt" onClick={() => navigate(-1)}>
            <IoMdArrowBack />
            &nbsp;Back
          </button>
          <main>
            <h1 style={{ textAlign: "center" }}>
              {selectedBrand === "Plan" ? "Plan Details" : "Card Details"}
            </h1>
            <div className="filters mb-3">
              <label htmlFor="brand">Select option</label>
              <select
                id="brand"
                value={selectedBrand}
                onChange={(e) => setSelectedBrand(e.target.value)}
              >
                <option value="Plan">Plan details</option>
                <option value="Card">Card details</option>
              </select>
            </div>
            <div className="col-lg-12">
              <table id="purifierTable">
                <thead>
                  <tr>
                    {lebl?.map((item, idx) => (
                      <th key={idx}>{item}</th>
                    ))}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedBrand === "Plan" &&
                    customersubscrip?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {getIntervaldata(
                            item?.interval,
                            item?.interval_count
                          )}
                        </td>
                        <td>£ {item?.price}</td>
                        <td>{item?.metadata?.level}</td>
                        <td>
                          <button
                            type="button"
                            className="btn color bg-white "
                            style={{ fontWeight: "600", color: "black" }}
                            onClick={() => handleShow(item.subscription_id)}
                          >
                            Cancel
                          </button>
                        </td>
                      </tr>
                    ))}
                  {selectedBrand === "Card" &&
                    cardDetails?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.name_on_card}</td>
                        <td>{`*** *** **** ${item?.card_number}`}</td>
                        <td>{item?.exp_year}</td>
                        <td>
                          {cardDetails?.length === 1 ? (
                            <button
                              type="button"
                              className="btn color bg-white "
                              style={{ fontWeight: "600" }}
                              disabled
                            >
                              Disable
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn color bg-white "
                              style={{ fontWeight: "600" }}
                              onClick={() => handleDelete(item?.id)}
                            >
                              Delete
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {selectedBrand === "Plan" && customersubscrip?.length === 0 && (
                <p className="detailscenter">
                  <b>No Plan Details Found</b>
                </p>
              )}
              {selectedBrand === "Card" && cardDetails?.length === 0 && (
                <p className="detailscenter">
                  <b>No Plan Details Found</b>
                </p>
              )}
            </div>
          </main>
        </div>
        {/* {selectedBrand === "Plan" && customersubscrip.length === 0 && (
          <p className="detailscenter">
            <b>No Plan Details Found</b>
          </p>
        )}
        {selectedBrand === "Card" && cardDetails.length === 0 && (
          <p className="detailscenter">
            <b>No Card Details Found</b>
          </p>
        )} */}
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "red" }}> Warning !</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-p-css ">
            <b> Are you sure you want to cancel?</b>
          </p>
        </Modal.Body>
        <Modal.Footer style={{ textAlign: "center", justifyContent: "center" }}>
          <Button className="save_btn" onClick={handlesubcrip}>
            Yes
          </Button>
          <Button className="can_btn" onClick={handleClose}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Plandetails;
